function createSortSelectAutoWidth() {
  const measureEl = document.createElement('span');
  measureEl.setAttribute('aria-hidden', 'true');
  measureEl.style.cssText =
    'position:absolute;top:-9999px;visibility:hidden;white-space:nowrap;pointer-events:none;';
  document.body.appendChild(measureEl);

  const updateWidth = (select) => {
    const option = select.options[select.selectedIndex];
    if (!option) return;

    const style = getComputedStyle(select);
    measureEl.style.fontFamily = style.fontFamily;
    measureEl.style.fontSize = style.fontSize;
    measureEl.style.fontWeight = style.fontWeight;
    measureEl.style.letterSpacing = style.letterSpacing;
    measureEl.textContent = option.text.trim();

    const textWidth = measureEl.getBoundingClientRect().width;
    const pl = parseFloat(style.paddingLeft) || 0;
    const pr = parseFloat(style.paddingRight) || 0;

    select.style.width = `${Math.ceil(textWidth + pl + pr + 2)}px`;
  };

  const attached = new WeakSet();

  const initSelect = (select) => {
    if (attached.has(select)) return;
    attached.add(select);
    updateWidth(select);
    select.addEventListener('change', () => updateWidth(select));
  };

  const initAll = () => {
    document.querySelectorAll('.facet-filters__sort').forEach(initSelect);
  };

  initAll();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (node.matches && node.matches('.facet-filters__sort')) {
          initSelect(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('.facet-filters__sort').forEach(initSelect);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', createSortSelectAutoWidth);
